function isBase64Image(str) {
  return /^data:image\/(?:gif|png|jpeg|bmp|webp)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/g.test(
    str
  );
}

export default isBase64Image;
